import React, { useEffect, useState } from "react";
import Alerts from "../../util/Alerts";
import axios from "axios";
import { routes } from "../General";
import update from "react-addons-update";
import { useSelector } from "react-redux";
import { Card, CardBody, CardTitle, Label } from "reactstrap";

export const Siniestro = props => {
    const alert = React.useRef();
    const [item, setItem] = useState({ cf: {} });
    const [list, setList] = useState([]);
    const [ordenado, setOrdenado] = useState([]);
    const [cred, setCred] = useState(false);
    const user = useSelector(state => state.user);
    const [disablebutton, setdisable] = useState(false);
    const [nota, setNota] = useState("");
    const [message, setMessage] = useState("Procesando...");

    useEffect(() => {
        getTicket();
    }, []);

    const getTicket = () => {
        if (props.match.params.id) {
            axios
                .get(routes.apiVam + "/ticket/buscar", {
                    params: {
                        zohoId: props.match.params.id,
                    },
                })
                .then(resp => {
                    let tmp = resp.data;
                    if (tmp.list) {
                        let ind = 1;
                        tmp.list?.forEach(tmp => {
                            tmp.order = ind++;
                            tmp.cdCompania = tmp?.cdCompania || 1; // pa que no vaya null
                        });
                    }
                    setItem(tmp.ticket);
                    setList(tmp.list);
                    setOrdenado(tmp.list);
                    setDisableButtons(tmp.ticket.cf);
                    if (tmp.ticket) {
                        if (tmp.ticket.cf.cf_centro_medico) {
                            setCred(true);
                        }
                        if (tmp.ticket.isDeleted) {
                            setNota("Atención: El ticket se encuentra eliminado.");
                        }
                    } else {
                        setNota("Atención: El ticket se NO existe.");
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
    };

    const ordenarList = (item, nuevo, id) => {
        let listTmp = list.slice();
        let index = listTmp.findIndex(itm => itm.cdArchivo === id);
        item.order = nuevo;
        listTmp = update(listTmp, { $splice: [[index, 1, item]] });
        listTmp.sort((a, b) => a.order - b.order);
        setList(listTmp);
        setOrdenado(listTmp);
    };

    const enviarList = (list, bn = false) => {
        if (list.length) {
            setdisable(true);
            setMessage("Procesando...");
            axios
                .post(routes.apiVam + "/ticket/adjunto", {
                    list: list,
                    bn: bn,
                    zohoId: props.match.params.id,
                    cdCliente: list[0].cdCliente,
                    cdCompania: list[0]?.cdCompania || 1, // pa que no vaya null
                    cdCotizacion: list[0].cdCotizacion,
                    cdReclamo: list[0].cdReclamo,
                    cdIncapsiniestro: list[0].cdIncapsiniestro,
                    subject: item.subject,
                    ticketNumber: item.ticketNumber,
                    metadato: {
                        idUsuario: user.id,
                        username: user.usuario,
                        fecha: new Date(),
                    },
                })
                .then(resp => {
                    alert.current.show_info("Se ha creado con éxito");
                    setdisable(false);
                })
                .catch(error => {
                    setdisable(false);
                });
        } else {
            setdisable(false);
            alert.current.show_info("No existe archivos");
        }
    };

    const setDisableButtons = ticketFields => {
        if (ticketFields.cf_cd_incap_siniestro_org) return;
        setdisable(true);
        setMessage("Verifica que todos los campos se encuentren vinculados desde EFI");
    };

    return (
        <div className="content">
            <Alerts ref={alert} />
            <Card>
                <CardBody>
                    <CardTitle tag="h4">
                        {cred ? "Documento Crédito Hospitalario/Ambulatorio" : "Documento Asistencia Médica"}
                    </CardTitle>
                    <div className="container-fluid">
                        <div className="row mx-2">
                            <div className="col-6">
                                <h6>Información</h6>
                                <div className="row">
                                    <div className="form-group col-6">
                                        <Label className=" font-weight-bolder text-primary">Paciente: &nbsp;</Label>
                                        <span className="m-1">{item.cf.cf_nombre_del_reclamante}</span>
                                    </div>
                                    <div className="form-group col-6">
                                        <label className=" font-weight-bolder text-primary">Diagnóstico: &nbsp;</label>
                                        <span>{item.cf.cf_incapacidad}</span>
                                    </div>
                                    <div className="form-group col-6">
                                        <label className=" font-weight-bolder text-primary">Plan: &nbsp;</label>
                                        <span>{item.cf.cf_plan_contratado}</span>
                                    </div>
                                    <div className="form-group col-6">
                                        <label className=" font-weight-bolder text-primary">
                                            Nombre de quien envia el documento: &nbsp;
                                        </label>
                                        <span>{item.cf.cf_nombre_de_quien_escanea_el_documento}</span>
                                    </div>
                                    <div className="form-group col-6">
                                        <label className="font-weight-bolder text-primary">
                                            IncapSiniestroOrg: &nbsp;
                                        </label>
                                        <span className={item.cf.cf_cd_incap_siniestro_org || "text-danger"}>
                                            {item.cf.cf_cd_incap_siniestro_org ?? "Campo obligatorio desde EFI"}
                                        </span>
                                    </div>
                                </div>
                                {cred ? (
                                    <div className="row">
                                        {/*    si es credito aqui va lo que se necesite mostrar*/}
                                        <div className="form-group col-6">
                                            <label className=" font-weight-bolder text-primary">
                                                Centro Médico: &nbsp;
                                            </label>
                                            <span>
                                                {item.cf.cf_centro_medico === "null" ? "-" : item.cf.cf_centro_medico}
                                            </span>
                                        </div>
                                        <div className="form-group col-6">
                                            <label className=" font-weight-bolder text-primary">
                                                Médico tratante: &nbsp;
                                            </label>
                                            <span>{item.cf.cf_medico_tratante}</span>
                                        </div>
                                        <div className="form-group col-6">
                                            <label className=" font-weight-bolder text-primary">
                                                Observaciones Crédito Hospiatalario: &nbsp;
                                            </label>
                                            <span>{item.cf.cf_observaciones_credito_hospitalario}</span>
                                        </div>
                                        <div className="form-group col-6">
                                            <label className=" font-weight-bolder text-primary">
                                                Valor Presupuestado: &nbsp;
                                            </label>
                                            <span>{item.cf.cf_valor_presupuestado}</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="form-group col-6">
                                            <label className=" font-weight-bolder text-primary">
                                                Observaciones o instrucciones especiales: &nbsp;
                                            </label>
                                            <span>{item.cf.cf_observaciones_o_instrucciones_especiales}</span>
                                        </div>
                                    </div>
                                )}
                                <div className="row">
                                    <div className="col">
                                        <a
                                            className="btn btn-primary"
                                            href={`https://desk.zoho.com/support/prodeseg/ShowHomePage.do#Cases/dv/${props.match.params.id}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Ver Ticket
                                        </a>
                                    </div>
                                </div>
                                <div className="row m-1">
                                    <h6 className="my-5 text-danger">{nota}</h6>
                                </div>
                            </div>
                            <div className="col-6">
                                <h6>Archivos Subidos</h6>
                                <div className="table-responsive my-2">
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead className="text-center">
                                            <tr>
                                                <th>#</th>
                                                <th>Nombre</th>
                                                <th>Tipo</th>
                                                <th>Tamaño (KB)</th>
                                                <th>Ver Archivos</th>
                                                <th>Orden</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list?.map((itm, index) => (
                                                <tr key={itm.cdArchivo}>
                                                    <td className="text-center">{index + 1} </td>
                                                    <td>{itm.nombre}</td>
                                                    <td>{itm.mime.split("/").pop()}</td>
                                                    <td>{(itm.size / 1024).toFixed(2)}</td>
                                                    <td>
                                                        <a
                                                            className="btn btn-secondary"
                                                            href={itm.url}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Ver
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <input
                                                            className="form-control w50"
                                                            type="number"
                                                            min={1}
                                                            step={1}
                                                            value={itm.order}
                                                            onChange={e => {
                                                                if (e.target.value) {
                                                                    ordenarList(itm, e.target.value, itm.cdArchivo);
                                                                } else {
                                                                    ordenarList(itm, 0, itm.cdArchivo);
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <button
                                    onClick={() => {
                                        enviarList(ordenado);
                                    }}
                                    className="btn btn-primary"
                                    disabled={disablebutton}
                                >
                                    Cargar archivo a Color
                                </button>
                                <button
                                    onClick={() => {
                                        enviarList(ordenado, true);
                                    }}
                                    className="btn btn-secondary mx-2"
                                    disabled={disablebutton}
                                >
                                    Cargar archivo a B/N
                                </button>
                                {disablebutton && (
                                    <div className="row">
                                        <label className=" font-weight-bolder text-primary m-1 mx-4">{message}</label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};
